// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"95097bb8f809f20b5767","532":"3c126e2b3a01b6aa462a","589":"cb4a5a6329dc1c251271","691":"a95cce256d836bc4d228"}[chunkId] + ".js";
};